export default class URLResource {
  private url: string
  private name: string
  private extension: string

  constructor(url: string | string[]) {
    this.url = URLResource.normalizeUrl(url)
    this.name = this.parseName(this.url)
    this.extension = this.parseExtension(this.url)
  }

  getURL = () => this.url
  getName = () => this.name
  getFullName = () => this.name + '.' + this.extension
  getExtension = () => this.extension

  private parseName = (url: string) => {
    if (typeof url !== 'string' || url.length === 0) return ''
    // const b = url?.lastIndexOf('/')

    // if (b === -1) return ''

    // const e = url?.lastIndexOf('__')
    // if (e === -1) return ''

    // return url?.slice(b + 1, e)

    const splitUrlArr = url?.split('/')

    if (splitUrlArr?.length) return splitUrlArr[splitUrlArr.length - 1]
    else return ''
  }

  private parseExtension = (url: string) => {
    if (typeof url !== 'string' || url.length === 0) return ''
    const i = url?.lastIndexOf('.')
    if (i === 1) return ''
    return url?.slice(i + 1, url.length)
  }

  private static normalizeUrl = (input: string | string[]) => {
    let url: string = ''
    
    if (Array.isArray(input)) {
      const firstUrl = input.find((it) => typeof it === 'string' && it.trim().length > 0)
      url = firstUrl ?? ''
    } else {
      url = input ?? ''
    }

    if (!url || url.length === 0) return url

    // Trim whitespace
    url = url.trim()

    // Remove leading slashes before protocol (e.g., /https://... -> https://...)
    url = url.replace(/^\/+(https?:\/\/)/i, '$1')

    // Clean duplicate base URLs (e.g., https://example.com/https://example.com/path -> https://example.com/path)
    if (url.includes('://')) {
      url = URLResource.removeDuplicateBaseUrl(url)
    }

    return url
  }

  private static removeDuplicateBaseUrl = (url: string): string => {
    if (!url || url.length === 0) return url

    // Pattern to match protocol + domain (e.g., https://stg-verifacto.amable.in)
    const baseUrlPattern = /(https?:\/\/[^\/\s]+)/i
    const match = url.match(baseUrlPattern)
    
    if (!match) return url // No protocol found, return as is

    const baseUrl = match[1] // e.g., "https://stg-verifacto.amable.in"
    
    // Escape special regex characters in baseUrl for use in regex
    const escapedBaseUrl = baseUrl.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
    
    // Pattern to match: baseUrl followed by optional / followed by baseUrl
    // This handles:
    // - https://domain/https://domain/path (with slash)
    // - https://domainhttps://domain/path (without slash)
    // - https://domain//https://domain/path (with multiple slashes)
    const duplicatePattern = new RegExp(`(${escapedBaseUrl})\\/?\\1`, 'gi')
    
    // Keep replacing duplicates until no more are found (handles multiple duplicates)
    let cleaned = url
    let previous = ''
    let iterations = 0
    const maxIterations = 10 // Safety limit to prevent infinite loops
    
    while (cleaned !== previous && iterations < maxIterations) {
      previous = cleaned
      // Replace duplicate: baseUrl (optionally /) followed by baseUrl -> baseUrl/
      // This ensures we keep one baseUrl with a trailing slash for proper URL structure
      cleaned = cleaned.replace(duplicatePattern, '$1/')
      iterations++
    }

    return cleaned
  }
}
